import * as React from "react";
import { connect } from "react-redux";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { Correction, VisibleWizards } from "../../../Request/DcfRequestReducer";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { EntityLabelDisplay } from './EntityLabelDisplay';
import { MainState } from '../../../../Core/reducers';
import { useWebPortalApiClient } from "../../../../misc/api/WebPortalTokenClient";
import { useCurrentStudyConfigurationContext } from "../../../../Core/CurrentStudyConfigurationContext";
import { StudyScheduleVisit, Subject } from "webportalclient";

interface EntityLabelPreviewItemConnectedProps {
}

const PreviewSelector = (corrections: Correction[]): boolean => {
    return corrections.length === 3
        && corrections.find(c => c.entity === "Session" && c.field === "SubjectId") != undefined
        && corrections.find(c => c.entity === "Session" && c.field === "VisitScheduleId") != undefined
        && corrections.find(c => c.entity === "Session" && c.field === "ScheduleItemId") != undefined;
}

export const EntityLabelPreviewItem = ({ corrections }: CorrectionItemPreviewProps & EntityLabelPreviewItemConnectedProps): JSX.Element => {
    const client = useWebPortalApiClient();
    const [subjectOptions, setSubjectOptions] = React.useState<Subject[]>([]);
    const [visitScheduleItems, setVisitScheduleItems] = React.useState<StudyScheduleVisit[]>([]);
    const { study } = useCurrentStudyConfigurationContext();

    React.useEffect(() => {
        const getData = async () => {
            const subjectsResult = await client.client.getSubjects("id,number", `site/studyId eq ${study.id}`, undefined, "site($select=studyId)");
            setSubjectOptions(subjectsResult.value);

            const visitScheduleItemResult = await client.client.getStudyScheduleVisits("id,label,studyScheduleSessions,studySchedule", `studySchedule/studyId eq ${study.id}`, undefined, "studySchedule($select=studyId),studyScheduleSessions");
            setVisitScheduleItems(visitScheduleItemResult.value);
        }

        getData();
    }, []);

    if (!(PreviewSelector(corrections))) {
        return null;
    }

    const getLabel = (field: string, value: string) => {
        let label = "";
        switch (field) {
            case "SubjectId":
                const subject = subjectOptions.find(x => x.id === value);
                label = subject ? subject.number : "";
                break;
            case "VisitScheduleId":
                const visit = visitScheduleItems.find(x => x.id === value);
                label = visit ? visit.label : "";
                break;
            case "ScheduleItemId":
                const session = visitScheduleItems.map(x => x.studyScheduleSessions).flat().find(x => x.label === value || x.id === value);
                label = session ? session.label : "";
                break;
        }
        return label;
    }

    return (<>
        {corrections.map(c => (<CorrectionBreakdownItem
            fieldName={c.field}
            from={<EntityLabelDisplay entityLabel={{ id: c.oldValue, label: getLabel(c.field, c.oldValue) }} />}
            to={<EntityLabelDisplay entityLabel={{ id: c.newValue, label: getLabel(c.field, c.newValue) }} />}
        />))}
    </>);
};

const EntityLabelPreview: CorrectionItemPreview = {
    previewElement: connect<EntityLabelPreviewItemConnectedProps, never, CorrectionItemPreviewProps>(mapStateToProps)(EntityLabelPreviewItem),
    previewSelector: PreviewSelector
};



function mapStateToProps(state: MainState): EntityLabelPreviewItemConnectedProps {
    return {
    }
}

export default EntityLabelPreview;
